import { useState } from 'react';
import './App.css';

// Add each new web-ready image filename here after placing it in public/artwork.
const artworks = [
  '00206BF50B0F260220154340.jpg',
  '00206BF50B0F260220155800.jpg',
  '00206BF50B0F260220155843.jpg',
  '00206BF50B0F260220155929.jpg',
  '00206BF50B0F260220155953.jpg',
  '00206BF50B0F260220160055.jpg',
  '00206BF50B0F260220160109.jpg',
  '00206BF50B0F260220160145.jpg',
  '00206BF50B0F260220160211.jpg',
  '00206BF50B0F260220160239.jpg',
  '00206BF50B0F260220160317.jpg',
  '00206BF50B0F260220160338.jpg',
  '00206BF50B0F260220160359.jpg',
  '00206BF50B0F260220160442.jpg',
  '00206BF50B0F260220160511.jpg',
  '00206BF50B0F260220160542.jpg',
];

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle className="icon-dot" cx="17.4" cy="6.7" r="1" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <path d="m4 7 8 6 8-6" />
    </svg>
  );
}

function App() {
  const [currentArtwork, setCurrentArtwork] = useState(0);
  const isFirstArtwork = currentArtwork === 0;
  const isLastArtwork = currentArtwork === artworks.length - 1;
  const filename = artworks[currentArtwork];

  const showPrevious = () => {
    setCurrentArtwork((current) => Math.max(current - 1, 0));
  };

  const showNext = () => {
    setCurrentArtwork((current) => Math.min(current + 1, artworks.length - 1));
  };

  return (
    <main className="site-shell">
      <header className="site-header">
        <a className="wordmark" href="/" aria-label="Luna Studio home">Luna</a>
        <span className="edition">Selected work — {String(currentArtwork + 1).padStart(2, '0')}</span>
      </header>

      <section className="artwork" aria-label="Featured artwork">
        <button
          className="artwork-nav artwork-nav--previous"
          type="button"
          onClick={showPrevious}
          disabled={isFirstArtwork}
          aria-label="Show previous artwork"
        >
          <span aria-hidden="true">←</span>
        </button>
        <img
          src={`/artwork/${filename}`}
          alt="Artwork"
        />
        <button
          className="artwork-nav artwork-nav--next"
          type="button"
          onClick={showNext}
          disabled={isLastArtwork}
          aria-label="Show next artwork"
        >
          <span aria-hidden="true">→</span>
        </button>
      </section>

      <footer className="site-footer">
        <p>For studio visits and enquiries</p>
        <nav aria-label="Contact links">
          <a href="https://www.instagram.com/min_blomsterhave" target="_blank" rel="noreferrer" aria-label="Instagram">
            <InstagramIcon />
          </a>
          <a href="mailto:luna.endelt@gmail.com" aria-label="Email Luna Studio">
            <MailIcon />
          </a>
        </nav>
      </footer>
    </main>
  );
}

export default App;
